import { Block, SimpleInput } from '@aloft/toolkit-sui';

import { Controller, useFormContext } from 'react-hook-form';

import { AdjustmentSettingsHelperText } from '../../components/AdjustmentSettingsHelperText.tsx';
import { MarketAdjustmentsModalForm } from './types.ts';

export const CustomMonthlyRateMethodContent = () => {
  const formContext = useFormContext<MarketAdjustmentsModalForm>();

  return (
    <Block width="fit-content">
      <Controller
        control={formContext.control}
        name="marketAdjustments.cachedForms.dateOfSale.methodState.customMonthlyRate.rate"
        render={({ field }) => (
          <SimpleInput {...field} type="number" label="% Change per Month" precision={2} />
        )}
      />

      <AdjustmentSettingsHelperText helperText='*This method is equivalent to using "Custom Monthly Price" with the "Trends as Percentages" option turned on.' />
    </Block>
  );
};
